import { ClientConfig, createPublicClient, PublicClient, WebSocketTransport } from "viem";
import { chain } from "./chain";
import { transports } from "./transports";

export const clientOptions = {
  chain,
  transport: transports[chain.id],
  pollingInterval: 100,
} as const satisfies ClientConfig;

export const publicClient: PublicClient<WebSocketTransport> = createPublicClient(clientOptions);
